export default {
    en: {

    },
    ko: {

    }
}